import Repository from "@shared/services/api/abstracts/Repository";
import { PublicBaseSpaceSerializer } from "../types/seating-types";

export default class PublicBasedSpaceRepository extends Repository<PublicBaseSpaceSerializer> {
  public readonly repositoryName = "PublicBasedSpaceRepository";

  public readonly endpoint = "/api/public/venues/spaces/";
}
